import React, { useEffect, useState } from 'react';
import { useToast } from '@chakra-ui/react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Spinner,
  Text,
  Checkbox,
  Input,
  Button,
  Flex,
  useDisclosure,
} from '@chakra-ui/react';
import {
  GetCalculationById,
  updateCalculation,
  createCalculation,
} from '../api/calculation';
import { GetVirtualTags } from '../api/virtualTag';
import { GetAllTagsNormal } from '../api/tag';
import VirtualTagSelectorModal from '../components/VirtualTagSelectorModal';
import TagOrManualEntryModal from '../components/TagOrManualEntryModal';

const CreateFunctionPage = () => {
  const { id } = useParams();
  const [calculation, setCalculation] = useState(null);
  const [virtualTags, setVirtualTags] = useState([]);
  const [allTags, setAllTags] = useState([]);
  const [selectedResult, setSelectedResult] = useState(null);
  const [selectedVariable, setSelectedVariable] = useState(null);
  const [functionExpression, setFunctionExpression] = useState('');
  const [selectedOperand, setSelectedOperand] = useState(null);
  const [isResultSelected, setIsResultSelected] = useState(false);
  const [isOperandDisabled, setIsOperandDisabled] = useState(true);
  const [error, setError] = useState(null);
  const [functionTags, setFunctionTags] = useState([]);
  const [resultTag, setResultTag] = useState(null); // sol taraf
  const [expressionTokens, setExpressionTokens] = useState([]); // sağ taraf
  const [allRawTags, setAllRawTags] = useState([]); // filtresiz hali

  const {
    isOpen: isResultModalOpen,
    onOpen: onOpenResultModal,
    onClose: onCloseResultModal,
  } = useDisclosure();
  const {
    isOpen: isVariableModalOpen,
    onOpen: onOpenVariableModal,
    onClose: onCloseVariableModal,
  } = useDisclosure();

  // useEffect(() => {
  //   const fetchTags = async () => {
  //     try {
  //       const virtualTagData = await GetVirtualTags();
  //       setVirtualTags(
  //         virtualTagData.filter(
  //           group =>
  //             group.device &&
  //             group.device.some(
  //               device => device.connectionType === 'VirtualDevice'
  //             )
  //         )
  //       );

  //       const allTagData = await GetAllTagsNormal();
  //       const formattedNormalTags = allTagData.flatMap(group =>
  //         group.device
  //           .filter(device => device.tag && device.tag.length > 0)
  //           .map(device => ({
  //             deviceId: device.uuid,
  //             deviceName: device.name,
  //             tags: device.tag
  //               .filter(tag => tag.function !== 'VirtualTag')
  //               .map(tag => ({
  //                 registerId: tag.id,
  //                 name: tag.Name,
  //                 ...tag,
  //               })),
  //           }))
  //       );

  //       setAllTags(formattedNormalTags);
  //     } catch (err) {
  //       console.error('Failed to fetch tags:', err);
  //     }
  //   };

  //   const fetchCalculation = async () => {
  //     if (id !== 'new') {
  //       try {
  //         const data = await GetCalculationById(id);
  //         setCalculation(data);

  //         const uiFunc = data.ui_function || '';
  //         const [, right] = uiFunc.split('=');
  //         const rightTokens = right?.trim().split(/\s+/) || [];

  //         const virtualTagsList = virtualTags.flatMap(group =>
  //           group.device.flatMap(device => device.tag)
  //         );

  //         const matchingResultTag =
  //           virtualTagsList.find(tag => tag.id === data.result) || null;

  //         if (matchingResultTag) {
  //           setResultTag(matchingResultTag);
  //           setIsResultSelected(true);
  //         }

  //         setExpressionTokens(rightTokens);
  //         setIsOperandDisabled(false);
  //       } catch (err) {
  //         console.error('Failed to fetch calculation:', err);
  //         setError('Failed to fetch calculation');
  //       }
  //     } else {
  //       setCalculation({
  //         name: '',
  //         enabled: true,
  //       });
  //       setFunctionExpression('');
  //       setSelectedResult(null);
  //       setIsResultSelected(false);
  //       setIsOperandDisabled(true);
  //     }
  //   };

  //   fetchTags();
  //   fetchCalculation();
  // }, [id]);
  // 1. İlk olarak tag'leri getir
  useEffect(() => {
    const fetchTags = async () => {
      try {
        const virtualTagData = await GetVirtualTags();
        const filtered = virtualTagData.filter(
          group =>
            group.device &&
            group.device.some(
              device => device.connectionType === 'VirtualDevice'
            )
        );
        setVirtualTags(filtered);

        const allTagData = await GetAllTagsNormal();
        setAllRawTags(allTagData); // orijinal haliyle

        const formattedNormalTags = allTagData.flatMap(group =>
          group.device
            .filter(device => device.tag && device.tag.length > 0)
            .map(device => ({
              deviceId: device.uuid,
              deviceName: device.name,
              tags: device.tag
                .filter(tag => tag.function !== 'VirtualTag' && tag.type !== 10)
                .map(tag => ({
                  registerId: tag.id,
                  name: tag.Name,
                  ...tag,
                })),
            }))
        );
        setAllTags(formattedNormalTags);
      } catch (err) {
        console.error('Failed to fetch tags:', err);
      }
    };

    fetchTags();
  }, []);

  useEffect(() => {
    const fetchCalculation = async () => {
      if (id !== 'new' && virtualTags.length > 0) {
        try {
          const data = await GetCalculationById(id);
          setCalculation(data);

          const uiFunc = data.ui_function || '';
          const [, right] = uiFunc.split('=');
          const rightTokens = right?.trim().split(/\s+/) || [];

          const virtualTagsList = virtualTags.flatMap(group =>
            group.device.flatMap(device => device.tag)
          );

          const matchingResultTag =
            virtualTagsList.find(tag => tag.id === data.result) || null;

          if (matchingResultTag) {
            setResultTag(matchingResultTag);
            setIsResultSelected(true);
          }

          setExpressionTokens(rightTokens);
          setIsOperandDisabled(false);
        } catch (err) {
          console.error('Failed to fetch calculation:', err);
          setError('Failed to fetch calculation');
        }
      } else if (id === 'new') {
        setCalculation({
          name: '',
          enabled: true,
        });
        setFunctionExpression('');
        setSelectedResult(null);
        setIsResultSelected(false);
        setIsOperandDisabled(true);
      }
    };

    fetchCalculation();
  }, [id, virtualTags]);

  const handleSelectResult = tag => {
    if (!isResultSelected) {
      setSelectedResult(tag);
      setResultTag(tag);
      setExpressionTokens([]); // yeni seçildiği için önceki silinir

      setIsResultSelected(true);
      setIsOperandDisabled(false);
    }
    onCloseResultModal();
  };

  const handleOperandClick = operand => {
    const lastToken = expressionTokens[expressionTokens.length - 1];

    if (!resultTag) {
      toast({
        title: 'Result Required',
        description: 'You must select a result tag before adding an operand.',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });

      return;
    }

    const isLastOperand = ['+', '-', '*', '/'].includes(lastToken);
    const isOperand = ['+', '-', '*', '/', ')'].includes(operand);

    // 🛑 Eğer bir önceki token ( ise ve şimdiki token operand ise => HATALI
    const prevToken = expressionTokens[expressionTokens.length - 1];
    if (prevToken === '(' && ['+', '-', '*', '/'].includes(operand)) {
      toast({
        title: 'Invalid Usage',
        description:
          'An operand cannot come immediately after an opening parenthesis "(".',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });

      return;
    }

    if (isLastOperand && isOperand) {
      toast({
        title: 'Invalid Expression',
        description: 'Two operands cannot be placed side by side.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });

      return;
    }

    // ✅ Eğer ( eklenmek isteniyorsa, son token operand olmalı
    if (operand === '(' && expressionTokens.length > 0) {
      const isValidBeforeOpen = ['+', '-', '*', '/', '('].includes(lastToken);
      if (!isValidBeforeOpen) {
        toast({
          title: 'Invalid Parenthesis',
          description: 'An operand must come before the "(" symbol.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });

        return;
      }
    }

    // ✅ Eğer ) eklenmek isteniyorsa, son token variable olmalı
    if (operand === ')') {
      if (
        ['+', '-', '*', '/', '('].includes(lastToken) ||
        lastToken === undefined
      ) {
        toast({
          title: 'Invalid Parenthesis',
          description: 'A value must come before the ")" symbol.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });

        return;
      }
    }

    if (
      expressionTokens.length === 0 &&
      ['+', '-', '*', '/'].includes(operand)
    ) {
      toast({
        title: 'Invalid Start',
        description: 'An operand cannot come right after the "=" sign.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });

      return;
    }

    setIsOperandDisabled(false);
    setExpressionTokens(prev => [...prev, operand]);
  };

  const handleSelectVariable = tag => {
    setSelectedVariable(tag);
    setExpressionTokens(prev => [...prev, tag?.name || tag?.Name || '']);
    setSelectedOperand(null);
    setIsOperandDisabled(true);
    onCloseVariableModal();
  };

  const handleClear = () => {
    setFunctionExpression('');
    setSelectedResult(null);
    setSelectedVariable(null);
    setSelectedOperand(null);
    setIsResultSelected(false);
    setIsOperandDisabled(true);
    setExpressionTokens([]);
    setResultTag(null); // Sol tarafı da temizlemek için
  };

  const toast = useToast();
  const navigate = useNavigate();

  const handleSaveFunction = async () => {
    if (!calculation?.name?.trim()) {
      toast({
        title: 'Missing Information',
        description: 'Function Name cannot be empty.',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });

      return;
    }
    if (!resultTag || expressionTokens.length === 0) {
      toast({
        title: 'Missing Information',
        description: 'Both Result Tag and function expression are required.',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });

      return;
    }
    const [resultName, ...functionParts] = functionExpression.split('=');
    const functionBody = expressionTokens.join(' ');

    const fullExpression = `${resultTag.name} = ${functionBody}`;

    const virtualTagsList = virtualTags.flatMap(group =>
      group.device.flatMap(device => device.tag)
    );

    const matchedResultTag = virtualTagsList.find(
      tag =>
        tag.name === resultTag?.name?.trim() ||
        tag.Name === resultTag?.name?.trim()
    );

    if (!matchedResultTag) {
      toast({
        title: 'Error',
        description: 'Please select a valid result tag.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });

      return;
    }

    const combinedTags = [
      ...allRawTags.flatMap(group =>
        group.device.flatMap(device => device.tag ?? [])
      ),
      ...virtualTags.flatMap(group =>
        group.device.flatMap(device => device.tag ?? [])
      ),
    ];

    const functionWithIds = expressionTokens
      .map(token => {
        const tag = combinedTags.find(
          t => t.name === token || t.Name === token
        );
        return tag ? tag.id : token;
      })
      .join(' ');

    const functionIds = Array.from(
      new Set(functionWithIds.match(/[0-9a-fA-F-]{36}/g) || [])
    );

    const requestData = {
      name: calculation?.name,
      enabled: calculation?.enabled,
      result: matchedResultTag.id,
      function: functionWithIds,
      functiontags: functionIds,
    };

    try {
      if (id && id !== 'new') {
        await updateCalculation(id, requestData);
      } else {
        await createCalculation(requestData);
      }

      toast({
        title: 'Success',
        description: 'Calculation saved successfully.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });

      navigate('/settings/calculation');
    } catch (err) {
      console.error('Failed to save function:', err);
      toast({
        title: 'Error',
        description: err?.response?.data?.message || 'Failed to save function.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleUndo = () => {
    setExpressionTokens(prev => prev.slice(0, -1));
  };

  if (!calculation && !error) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" h="100vh">
        <Spinner size="lg" />
      </Box>
    );
  }

  if (error) {
    return (
      <Box textAlign="center" mt={5}>
        <Text color="red.500">{error}</Text>
      </Box>
    );
  }

  return (
    <Box p={2}>
      <Flex direction="column" gap={4}>
        <Box>
          <Text fontSize="sm">Function Name</Text>
          <Input
            value={calculation?.name || ''}
            onChange={e =>
              setCalculation(prev => ({ ...prev, name: e.target.value }))
            }
          />
        </Box>

        <Checkbox
          isChecked={calculation?.enabled}
          onChange={e =>
            setCalculation(prev => ({ ...prev, enabled: e.target.checked }))
          }
        >
          {calculation?.enabled ? 'Enabled' : 'Disabled'}
        </Checkbox>

        <Flex gap={8} alignItems="center">
          <Flex alignItems="center">
            <Text fontSize="sm" mr={2}>
              Result:
            </Text>
            <Button
              colorScheme="blue"
              onClick={onOpenResultModal}
              isDisabled={isResultSelected}
            >
              Add
            </Button>
          </Flex>

          <Flex alignItems="center">
            <Text fontSize="sm" mr={2}>
              Variable:
            </Text>
            <Button
              colorScheme="blue"
              onClick={onOpenVariableModal}
              isDisabled={!isResultSelected || isOperandDisabled}
            >
              Add
            </Button>
          </Flex>
        </Flex>

        <Box>
          <Text fontSize="sm">Operand:</Text>
          <Flex gap={2}>
            {['+', '-', '*', '/', '(', ')'].map(op => (
              <Button key={op} onClick={() => handleOperandClick(op)}>
                {op}
              </Button>
            ))}
          </Flex>
        </Box>

        <Box>
          <Text fontSize="md">Function:</Text>
          <Text fontSize="md" fontWeight="bold">
            {resultTag
              ? `${resultTag.name} = ${expressionTokens.join(' ')}`
              : 'Please select a result tag to create a function'}
          </Text>
        </Box>

        <Flex direction="column" gap={2} alignItems="flex-start">
          <Flex gap={1}>
            <Button colorScheme="red" onClick={handleClear}>
              Clear
            </Button>
            <Button colorScheme="yellow" onClick={handleUndo}>
              Undo
            </Button>
          </Flex>
          <Flex>
            <Flex direction="column" gap={2}>
              <Button
                colorScheme="blue"
                onClick={handleSaveFunction}
                isDisabled={!resultTag || expressionTokens.length === 0}
              >
                Save Function
              </Button>

              <Button
                variant="outline"
                onClick={() => navigate('/settings/calculation')}
              >
                Cancel
              </Button>
            </Flex>
          </Flex>
        </Flex>
      </Flex>

      <VirtualTagSelectorModal
        isOpen={isResultModalOpen}
        onClose={onCloseResultModal}
        virtualTags={virtualTags}
        onSelect={handleSelectResult}
      />
      <TagOrManualEntryModal
        isOpen={isVariableModalOpen}
        onClose={onCloseVariableModal}
        tags={allTags}
        onSelect={handleSelectVariable}
      />
    </Box>
  );
};

export default CreateFunctionPage;
